"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.milestoneDateTypeValues = exports.MilestoneDateType = void 0;
var MilestoneDateType;
(function (MilestoneDateType) {
    MilestoneDateType["DateOnly"] = "dateOnly";
    MilestoneDateType["DateTime"] = "dateTime";
    MilestoneDateType["DateTimeInterval"] = "dateTimeInterval";
})(MilestoneDateType || (exports.MilestoneDateType = MilestoneDateType = {}));
exports.milestoneDateTypeValues = Object.values(MilestoneDateType);
//# sourceMappingURL=milestoneDate.type.js.map